// extracted by mini-css-extract-plugin
export default {"inline":"_1OegX","container":"_1za2y","noSpacing":"_2magj","dotWrapper":"_1PZDN","background":"_1uWc6","dot":"_2hffs","word":"_3SUSJ","number":"_3wCxp"};